import { __awaiter, __extends, __generator, __read } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { Dispatcher } from 'flux';
import { Module } from '.';
import { ModuleError } from './ModuleError';
var SearchDispatcher = /** @class */ (function (_super) {
    __extends(SearchDispatcher, _super);
    function SearchDispatcher(searchSettings, searchModules, searchHostAppLogger) {
        var _this = _super.call(this, 'Search_Dispatcher') || this;
        _this.fastLogEventBuffer = [];
        _this.fastLogEventBufferUnregisterToken = '';
        _this.searchSettings = searchSettings;
        _this.searchModules = searchModules;
        _this.searchHostAppLogger = searchHostAppLogger;
        return _this;
    }
    SearchDispatcher.prototype.cleanLogEventBuffer = function () {
        this.fastLogEventBuffer.length = 0;
    };
    SearchDispatcher.prototype.copyLogEventBuffer = function () {
        return this.fastLogEventBuffer.slice(0);
    };
    SearchDispatcher.prototype.getLogEventBufferUnregisterToken = function () {
        return this.fastLogEventBufferUnregisterToken;
    };
    SearchDispatcher.prototype.initializeModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, dispatcherModule, identity, dispatcher, isMsa_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.fetchModule(),
                            this.searchSettings.getIdentity(),
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 2]), dispatcherModule = _a[0], identity = _a[1];
                        try {
                            dispatcher = new Dispatcher();
                            dispatcherModule.setDispatcher(dispatcher);
                            isMsa_1 = identity.isMsa;
                            /**
                             * Register the Office.com dispatcher that will have custom
                             * Office.com specific mapping from SERP events
                             */
                            dispatcher.register(function (logEvent) {
                                if (logEvent.eventType !== 'USAGE') {
                                    return;
                                }
                                _this.searchHostAppLogger.searchLogger({
                                    isMsa: isMsa_1,
                                    logEvent: logEvent,
                                });
                            });
                            /**
                             * Register the SERP dispatcher and handles buffering
                             */
                            this.fastLogEventBufferUnregisterToken = dispatcher.register(function (logEvent) {
                                _this.fastLogEventBuffer.push(logEvent);
                            });
                            this.module.resolve(dispatcherModule);
                        }
                        catch (_) {
                            throw new ModuleError('Search_Dispatcher', 'Initialization_Error');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchDispatcher.prototype.fetchModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query;
            var _this = this;
            return __generator(this, function (_a) {
                query = ['SearchDispatcherModule'];
                return [2 /*return*/, queryCache.fetchQuery(query, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.searchModules.getModule()];
                            case 1: return [2 /*return*/, (_a.sent()).loadSearchDispatcher()];
                        }
                    }); }); }, {
                        cacheTime: Infinity,
                        staleTime: Infinity,
                        onError: function () {
                            throw new ModuleError('Search_Dispatcher', 'Fetching_Error');
                        },
                    })];
            });
        });
    };
    return SearchDispatcher;
}(Module));
export { SearchDispatcher };
//# sourceMappingURL=SearchDispatcher.js.map